import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CloudEnvironment,
  ErmDevOpsApiClientService,
  UpdateCloudEnvironmentRequest,
  UpdateCloudEnvironmentResponse
} from 'erm-sdk';

@Component({
  standalone: false,
  selector: 'app-update-environment',
  templateUrl: './update-environment.component.html',
  styleUrls: ['./update-environment.component.scss']
})
export class UpdateEnvironmentComponent {

  isSaving: boolean = false;
  booleanCollection: boolean[] = [true, false];
  updateCloudEnvironmentRequest: UpdateCloudEnvironmentRequest;
  updateCloudEnvironmentResponse?: UpdateCloudEnvironmentResponse;

  constructor(private ermDevOpsApiClient: ErmDevOpsApiClientService,
    @Inject(MAT_DIALOG_DATA) public selectedEnvironment: CloudEnvironment,
    public dialogRef: MatDialogRef<UpdateEnvironmentComponent>) {
    this.updateCloudEnvironmentRequest = {
      environmentId: selectedEnvironment.environmentId,
      description: selectedEnvironment.description,
      isAvailable: selectedEnvironment.isAvailable,
      isEnabled: selectedEnvironment.isEnabled,
      inMaintenanceMode: selectedEnvironment.inMaintenanceMode,
      statusMessage: selectedEnvironment.statusMessage
    } as UpdateCloudEnvironmentRequest;
  }

  async save(): Promise<void> {
    try {
      this.isSaving = true;
      const updateCloudEnvironmentResponse = await this.ermDevOpsApiClient.updateCloudEnvironment(this.updateCloudEnvironmentRequest);
      this.updateCloudEnvironmentResponse = updateCloudEnvironmentResponse.body as UpdateCloudEnvironmentResponse;
    } finally {
      this.isSaving = false;
    }
  }

  close(): void {
    if (this.updateCloudEnvironmentResponse) {
      this.selectedEnvironment.isAvailable = this.updateCloudEnvironmentResponse.isAvailable;
      this.selectedEnvironment.isEnabled = this.updateCloudEnvironmentResponse.isEnabled;
      this.selectedEnvironment.inMaintenanceMode = this.updateCloudEnvironmentResponse.inMaintenanceMode;
      this.selectedEnvironment.statusMessage = this.updateCloudEnvironmentResponse.statusMessage;
      this.selectedEnvironment.version = this.updateCloudEnvironmentResponse.version;
      this.dialogRef.close({ data: this.selectedEnvironment });
    }
    else {
      this.dialogRef.close({ data: undefined });
    }
  }
}
